import { camelCase, upperFirst } from 'lodash'

export * from './tracking'

// Change Boolean Helper
export function changeBool(self, key) {
  self[key] = !self[key]
}

// snake_case to PascalCase
export const snakeToPascal = str => upperFirst(camelCase(str))

// Punct to slash
export const punctToSlash = str => str.replace(/\./g, '/')

// object_type to type
export function objectTypeToType(object_type) {
  // if object_type is combined parent.children object, return only last children
  return object_type.indexOf('.') > -1 ? object_type.split('.').pop() : object_type
}

// clean object
// We can’t use Lodash because it clones objects but keeps Vue reactivity; here we intentionally need a plain, non-reactive object.
export function cleanSource(source) {
  // using native JSON functions removes reactivity
  // so we can clone an object without mutating the original source
  return JSON.parse(JSON.stringify(source))
}

// TODO: display the modal with vue?
export function toggleModal(name, title, html) {
  // eslint-disable-next-line
  $.modal({
    name: name,
    title: title,
    html: html,
  })
}

// TODO: display the modal with vue?
export function showSnackbar(type, icon, message) {
  try {
    const $ = typeof window !== 'undefined' && (window.$ || window.jQuery)
    if ($?.showSnackbar) {
      $.showSnackbar(type, icon, message)
    } else if (typeof window !== 'undefined' && message) {
      window.alert(message)
    }
  } catch (e) {
    if (typeof window !== 'undefined' && message) window.alert(message)
  }
}

export function toggleBodyClass(className) {
  const el = document.body

  if (el.classList.contains(className)) {
    el.classList.remove(className)
  } else {
    el.classList.add(className)
  }
}

export function toggleHtmlClass(className) {
  const el = document.getElementsByTagName('html')[0]

  if (el.classList.contains(className)) {
    el.classList.remove(className)
  } else {
    el.classList.add(className)
  }
}

export function findInArray(array, value) {
  return array && array.find(ele => ele === value)
}

export function parseCurrency(value) {
  if (!value) return 0;

  return Number(
    value
      .toString()
      .replace(/\s/g, "")        // remove spaces
      .replace(/[^\d,.-]/g, "")  // remove currency symbols
      .replace(/\./g, "")        // remove thousand separators
      .replace(",", ".")         // convert decimal comma to dot
  );
}

// utils/browserInfo.js
export function getBrowserInfo() {
  return {
    acceptHeader: navigator.acceptLanguage || "",
    colorDepth: window.screen.colorDepth || 24,
    javaEnabled: navigator.javaEnabled ? navigator.javaEnabled() : false,
    language: navigator.language || navigator.userLanguage || "",
    screenHeight: window.screen.height,
    screenWidth: window.screen.width,
    timeZoneOffset: String(new Date().getTimezoneOffset()),
    userAgent: navigator.userAgent
  }
}

export const scrollToError = () => {
  // Check if an interval is already running and clear it to prevent duplicates
  if (window.scrollToError) {
    clearInterval(window.scrollToError)
  }

  window.scrollToError = setInterval(() => {
    const isModalActive = document.body.classList.contains('base-modal-active')
    const modalContainer = document.querySelector('.base-modal-body')
    const error = isModalActive
      ? document.querySelector('.base-modal-body .error')
      : document.querySelector('.error')

    if (error) {
      if (isModalActive && modalContainer) {
        // Calculate position of error relative to the modal container
        const containerRect = modalContainer.getBoundingClientRect()
        const errorRect = error.getBoundingClientRect()

        // Calculate scroll offset
        const scrollOffset = (errorRect.top - containerRect.top) + modalContainer.scrollTop

        modalContainer.scrollTo({
          top: scrollOffset - 50, // Keep 50px buffer
          behavior: 'smooth',
        })
      } else {
        error.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }

      // Clear the interval and reset the window property
      clearInterval(window.scrollToError)
      window.scrollToError = null
    }
  }, 200)
}

export const getItemImage = item => {
  if (item.is_custom_voucher) {
    const id = item?.datafield?.design
    const localCardStyles = window && window.localStorage && window.localStorage.getItem('cardStyles')
    const cardStyles = localCardStyles ? JSON.parse(localCardStyles) : window.cardStyles || []
    if (id) {
      const selectedCard = cardStyles?.find(item => item.id === Number(id))
      return selectedCard?.image || ''
    }
    return ''
  } else {
    return item.product?.main_image?.thumb || ''
  }
}
